import { CheckBadge } from "@/components/doorman/LedgerTable";

const ROWS = [
  ["09:41:07", "↗ ChatGPT", "OpenAI · Guest Wi-Fi", "verified"],
  ["09:41:12", "↗ Microsoft 365 Copilot", "Microsoft · Front desk", "verified"],
  ["09:41:19", "↘ ChatGPT-User", "OpenAI · Booking server", "verified"],
  ["09:41:26", "↘ Undeclared agent", "headless browser · Booking server", "undeclared"],
  ["09:41:33", "↘ GPTBot", "claims OpenAI · Booking server", "failed"],
  ["09:41:40", "↗ OpenAI API", "OpenAI · Back office", "verified"],
];

export const HeroLedger = () => (
  <div className="rounded-lg border border-[#222D3D] bg-[#0F141C]/90 backdrop-blur shadow-2xl shadow-emerald-500/5 overflow-hidden" data-testid="landing-hero-ledger">
    <div className="flex items-center justify-between px-5 py-3 border-b border-[#222D3D]">
      <span className="text-[11px] font-semibold tracking-[0.18em] uppercase text-slate-500">Arrivals · today</span>
      <span className="flex items-center gap-2 font-mono text-[11px] text-emerald-300"><span className="h-1.5 w-1.5 rounded-full bg-emerald-400 pulse-dot" />example</span>
    </div>
    <ul>
      {ROWS.map(([t, who, sub, status], i) => (
        <li key={t} className="fade-up flex items-center gap-4 px-5 py-3 border-b border-[#222D3D]/60 last:border-0" style={{ animationDelay: `${0.15 + i * 0.12}s` }}>
          <span className="font-mono text-xs text-slate-500 w-16 shrink-0">{t}</span>
          <div className="min-w-0 flex-1">
            <p className="text-sm text-slate-100 truncate">{who}</p>
            <p className="text-xs text-slate-500 truncate">{sub}</p>
          </div>
          <CheckBadge status={status} />
        </li>
      ))}
    </ul>
    <div className="px-5 py-3 border-t border-[#222D3D] font-mono text-[11px] text-slate-500 flex justify-between">
      <span>chain intact · 1,204 entries</span>
      <span className="text-[#F7931A]">anchored to Bitcoin</span>
    </div>
  </div>
);
